import { Controller } from "react-hook-form";
import { FormControl, FormHelperText, FormLabel } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { useLanguageTranslator } from "../../../../../../components";

const YearPickerField = () => {
  const { translator } = useLanguageTranslator();
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Controller
        name="year"
        rules={{ required: "Required!" }}
        render={({ field, fieldState: { error } }) => (
          <FormControl
            fullWidth
            required
            error={!!error}
            disabled={false}
            sx={{ margin: "0px" }}
          >
            <FormLabel>{translator("Year")}</FormLabel>
            <DatePicker
              views={["year"]}
              {...field}
              value={field.value || null}
              onChange={(newValue) => field.onChange(newValue)}
            />
            <FormHelperText>{error?.message}</FormHelperText>
          </FormControl>
        )}
      />
    </LocalizationProvider>
  );
};

export default YearPickerField;
